import { useContext, useState, useEffect } from 'react';
import './Style.less';
import { EditContext } from '@/context/EditContext';
import EditStyle from '@/pages/edit/components/subtitleStyle/components/EditStyle';
import { projectController } from '@/api/edit';
import { useTranslation } from 'react-i18next';
import DisplayCheckImg from '@/assets/edit/displayCheckImg.svg';
import EditSubtitleStyle from '@/assets/edit/editSubtitleStyle.svg';
/**
 * 字幕布局组件
 * 用于控制视频字幕的显示布局和视频比例
 */
const bilingualSubtitleList = [
  {
    id: 0,
    title: 'As_Edit_ExportSubtitleOff334',
  },
  {
    id: 1,
    title: 'As_Edit_ExportSubtitleOriginal334',
  },
  {
    id: 2,
    title: 'As_Edit_ExportSubtitleTarget334',
  },
  {
    id: 3,
    title: 'As_Edit_ExportSubtitleBilingual334',
  },
];
const originalSubtitleList = [
  {
    id: 0,
    title: 'As_Edit_ExportSubtitleOff334',
  },
  {
    id: 1,
    title: 'As_Edit_ExportSubtitleOriginal334',
  },
];
export default function Style() {
  const { showEditCaptions } = useContext(EditContext);
  return (
    <>
      <div style={{ height: '100%', display: !showEditCaptions ? 'block' : 'none' }}>
        <StyleList />
      </div>
      {showEditCaptions && <EditStyle />}
    </>
  );
}

function StyleList() {
  const { t } = useTranslation();
  const {
    sessionId,
    // isTranslated,
    useTranslate,
    subtitleShow,
    setSubtitleShow,
    presetData,
    setShowEditCaptions,
    setCaptionsItem,
    setNewCaptionsItem,
    captionsId,
    setCaptionsId,
    newcaptionsId,
    setNewcaptionsId,
    projectDetail,
    setProjectDetail,
    fontSizeBox,
    doubleFontSizeBox,
    selectedAspectRatio,
  } = useContext(EditContext);
  const [styleList, setStyleList] = useState([]);
  const [selectSubtitleList, setSelectSubtitleList] = useState([]);
  // 获取下拉框渲染数据
  useEffect(() => {
    if (useTranslate) {
      setSelectSubtitleList(bilingualSubtitleList);
    } else {
      setSelectSubtitleList(originalSubtitleList);
    }
  }, [presetData, subtitleShow, useTranslate]);
  // 监听变化更新字幕数据
  useEffect(() => {
    // 双语
    if (subtitleShow === 3) {
      if (presetData.bilingualismSubtitles) {
        let originalFontSize = 0;
        let translateFontSize = 0;
        if (selectedAspectRatio === 0) {
          originalFontSize = doubleFontSizeBox.originalFontSize169;
          translateFontSize = doubleFontSizeBox.translateFontSize169;
        }
        if (selectedAspectRatio === 1) {
          originalFontSize = doubleFontSizeBox.originalFontSize11;
          translateFontSize = doubleFontSizeBox.translateFontSize11;
        }
        if (selectedAspectRatio === 2) {
          originalFontSize = doubleFontSizeBox.originalFontSize916;
          translateFontSize = doubleFontSizeBox.translateFontSize916;
        }
        if (selectedAspectRatio === 3) {
          originalFontSize = doubleFontSizeBox.originalFontSizeCtm;
          translateFontSize = doubleFontSizeBox.translateFontSizeCtm;
        }
        const obj = presetData.bilingualismSubtitles.find(
          (item) => item.subtitleId === newcaptionsId,
        );
        setStyleList(presetData.bilingualismSubtitles);
        if (projectDetail.diySubtitles.length) {
          const captionsIndex1 = projectDetail.diySubtitles.findIndex((item) => item.type === 1);
          if (captionsIndex1 !== -1) {
            setNewCaptionsItem({
              ...projectDetail.diySubtitles[captionsIndex1],
              fontSize: translateFontSize,
            });
          } else {
            setNewCaptionsItem({ ...obj.subtitleArr[1], fontSize: translateFontSize });
          }

          const captionsIndex0 = projectDetail.diySubtitles.findIndex((item) => item.type === 0);
          if (captionsIndex0 !== -1) {
            setCaptionsItem({
              ...projectDetail.diySubtitles[captionsIndex0],
              fontSize: originalFontSize,
            });
          } else {
            setCaptionsItem({ ...obj.subtitleArr[0], fontSize: originalFontSize });
          }
          return;
        }
        setCaptionsItem({ ...obj.subtitleArr[0], fontSize: originalFontSize });
        setNewCaptionsItem({ ...obj.subtitleArr[1], fontSize: translateFontSize });
        setNewcaptionsId(newcaptionsId);
      }
    } else {
      // 单语
      if (presetData.monolingualSubtitles) {
        let originalFontSize = 0;
        if (selectedAspectRatio === 0) {
          originalFontSize = fontSizeBox.fontSize169;
        }
        if (selectedAspectRatio === 1) {
          originalFontSize = fontSizeBox.fontSize11;
        }
        if (selectedAspectRatio === 2) {
          originalFontSize = fontSizeBox.fontSize916;
        }
        if (selectedAspectRatio === 3) {
          originalFontSize = fontSizeBox.fontSizeCtm;
        }
        setStyleList(presetData.monolingualSubtitles);
        // 判断如果有自定义字幕样式用自定义样式
        if (projectDetail.diySubtitles.length) {
          if (subtitleShow === 2) {
            setNewCaptionsItem({ ...projectDetail.diySubtitles[0], fontSize: originalFontSize });
          } else {
            setCaptionsItem({ ...projectDetail.diySubtitles[0], fontSize: originalFontSize });
          }
          return;
        }
        // 没有自定义样式用id索引的样式
        const obj = presetData.monolingualSubtitles.find((item) => item.subtitleId === captionsId);

        if (subtitleShow === 2) {
          setNewCaptionsItem({ ...obj, fontSize: originalFontSize });
        } else {
          setCaptionsItem({ ...obj, fontSize: originalFontSize });
        }
        setCaptionsId(captionsId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subtitleShow, newcaptionsId, captionsId, projectDetail.diySubtitles]);
  useEffect(() => {
    // 双语
    if (subtitleShow === 3) {
      if (presetData.bilingualismSubtitles) {
        let originalFontSize = 0;
        let translateFontSize = 0;
        if (selectedAspectRatio === 0) {
          originalFontSize = doubleFontSizeBox.originalFontSize169;
          translateFontSize = doubleFontSizeBox.translateFontSize169;
        }
        if (selectedAspectRatio === 1) {
          originalFontSize = doubleFontSizeBox.originalFontSize11;
          translateFontSize = doubleFontSizeBox.translateFontSize11;
        }
        if (selectedAspectRatio === 2) {
          originalFontSize = doubleFontSizeBox.originalFontSize916;
          translateFontSize = doubleFontSizeBox.translateFontSize916;
        }
        if (selectedAspectRatio === 3) {
          originalFontSize = doubleFontSizeBox.originalFontSizeCtm;
          translateFontSize = doubleFontSizeBox.translateFontSizeCtm;
        }
        setNewCaptionsItem((prev) => ({
          ...prev,
          fontSize: translateFontSize,
        }));
        setCaptionsItem((prev) => ({
          ...prev,
          fontSize: originalFontSize,
        }));
      }
    } else {
      // 单语
      if (presetData.monolingualSubtitles) {
        let originalFontSize = 0;
        if (selectedAspectRatio === 0) {
          originalFontSize = fontSizeBox.fontSize169;
        }
        if (selectedAspectRatio === 1) {
          originalFontSize = fontSizeBox.fontSize11;
        }
        if (selectedAspectRatio === 2) {
          originalFontSize = fontSizeBox.fontSize916;
        }
        if (selectedAspectRatio === 3) {
          originalFontSize = fontSizeBox.fontSizeCtm;
        }

        if (subtitleShow === 2) {
          setNewCaptionsItem((prev) => ({
            ...prev,
            fontSize: originalFontSize,
          }));
        } else {
          setCaptionsItem((prev) => ({
            ...prev,
            fontSize: originalFontSize,
          }));
        }
      }
    }
  }, [subtitleShow, selectedAspectRatio]);
  const handleSelectStyleItem = (item) => {
    window.onClickGATrackEvent('subtitle-change-prefab', {
      sub_id: item.subtitleId,
    });

    if (subtitleShow !== 3) {
      setCaptionsId(item.subtitleId);
      setCaptionsItem(item);
      if (subtitleShow === 2) {
        setNewCaptionsItem(item);
      }
    } else {
      setNewcaptionsId(item.subtitleId);
      setCaptionsItem(item.subtitleArr[0]);
      setNewCaptionsItem(item.subtitleArr[1]);
    }
    setProjectDetail((prevDetail) => ({
      ...prevDetail,
      diySubtitles: [],
    }));
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.subtitleStyle({
        projectId: projectItem.id,
        body: {
          sessionId,
          subtitlesStyleId: item.subtitleId,
          subtitleIdType: subtitleShow === 3 ? 1 : 0,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickEditSubtitle = () => {
    setShowEditCaptions(true);
  };
  const handleSelectsubtitleShowItem = (item) => {
    setProjectDetail((prevDetail) => ({
      ...prevDetail,
      subtitleShow: item.id,
      diySubtitles: [],
    }));
    setSubtitleShow(item.id);
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.updateSubtitleShow({
        projectId: projectItem.id,
        body: {
          subtitleShowEnum: item.id,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="subtitle_style_box">
      {/* 布局标题 */}
      <div className="title_box">
        <div className="title">{t('As_Edit_Navchoice5')}</div>
        <div className="select_subtitle_display">
          <div className="text">{t('As_Edit_SubtitleDisplay334')}</div>
          <div className="select_subtitle_list">
            {selectSubtitleList.map((item, index) => (
              <div
                key={index}
                className={`select_subtitle_item ${subtitleShow === item.id && 'select_subtitle_item_active'}`}
                onClick={() => {
                  handleSelectsubtitleShowItem(item);
                }}>
                <span className="title_text">{t(item.title)}</span>
                <img
                  src={DisplayCheckImg}
                  style={{ display: subtitleShow === item.id ? 'block' : 'none' }}
                  alt=""
                  className="check_img"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 布局选项列表 */}
      <div className="style_options">
        {/* {list.map((item, index) => ( */}
        {styleList.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              handleSelectStyleItem(item);
            }}
            className={`style_options_item ${
              (subtitleShow !== 3
                ? captionsId === item.subtitleId
                : newcaptionsId === item.subtitleId) && 'active_style_options_item'
            }`}>
            <img className="item_img" src={item.fontUrl} alt="" />
            <div className="item_icon" onClick={handleClickEditSubtitle}>
              {/* <Icon name="icon-edit" className="icon_edit" /> */}
              <img src={EditSubtitleStyle} alt="" className="edit_style_img" />
            </div>
          </div>
        ))}
        {/* ))} */}
      </div>
    </div>
  );
}
